import {
  BRANDED_EMPTY_LABEL,
  BRANDED_LABEL,
  UNBRANDED_LABEL,
} from '@/utils/branded'

// Mapping from singular to plural forms for API endpoints
const pluralMapping: Record<string, string> = {
  company: 'companies',
  counterparty: 'companies',
  product: 'products',
  terminal: 'terminals',
  site: 'sites',
  tank: 'tanks',
}

/**
 * Get the plural form for API endpoints
 */
const getPluralType = (entityType: string): string => {
  return pluralMapping[entityType] || entityType
}

/**
 * Check if entity type is a company/counterparty
 */
export const isCompanyType = (entityType: string): boolean => {
  return entityType === 'company' || entityType === 'counterparty'
}

/**
 * Get API endpoint for entity type
 */
export const getEntityEndpoint = (entityType: string): string => {
  if (isCompanyType(entityType)) {
    return '/crossroads/network/companies/'
  }
  const pluralType = getPluralType(entityType)
  return `/crossroads/entity/${pluralType}/`
}

/**
 * Get Grid API endpoint for entity type
 */
export const getGridEndpoint = (entityType: string): string => {
  if (isCompanyType(entityType)) {
    return '/crossroads/network/companies/grid'
  }
  const pluralType = getPluralType(entityType)
  return `/crossroads/entity/${pluralType}/grid`
}

/**
 * Get entity ID from row data
 */
export const getEntityId = (
  rowData: Record<string, unknown>,
  entityType: string,
): string => {
  if (isCompanyType(entityType)) {
    return rowData._id
  }
  return rowData.id || rowData._id || rowData.goid
}

/**
 * Convert form values to API payload
 */
export const convertFormDataToPayload = (
  formData: Record<string, unknown>,
): Record<string, unknown> => {
  return Object.keys(formData).reduce(
    (acc, key) => {
      if (typeof formData[key] === 'boolean') {
        acc[key] = formData[key]
      } else if (formData[key] === 'Yes' || formData[key] === BRANDED_LABEL) {
        acc[key] = true
      } else if (formData[key] === 'No' || formData[key] === UNBRANDED_LABEL) {
        acc[key] = false
      } else if (formData[key] === BRANDED_EMPTY_LABEL) {
        acc[key] = null
      } else {
        acc[key] = formData[key]
      }
      return acc
    },
    {} as Record<string, unknown>,
  )
}
